import LoadingScreen from 'components/LoadingScreen';
import { Seo } from 'components/Seo';
import { ReportResponse } from 'models/StatisticsReport';
import { useEffect, useState } from 'react';
import { useParams,Link } from 'react-router-dom';
import { statisticsService } from 'services/Services';
import { Potential, DetailedDisplays, SearchWord, RelevantAlternatives, Visibility, ActivityAndTraffic, GeographicalInfosite, PotentialTradeArea, TelephoneInquiries, ClickInquiries, RoiCalculator} from './Reports';
import BreadcrumbCompany from "../BreadcrumbCompany";
import { UrlPath } from "utility/routes";
//import ToolTip from './Components/Tooltip';
import {formatDate} from 'utility/formatDate';
import ModalStatDate from './Components/ModalStatDate';
import Blog from 'components/Blog';

type DmStatsProps = {
  data: ReportResponse;
}

export default function Statistics(){
  let params = useParams();
  
  const [loading, setLoading] = useState(true);
  const [report, setReport] = useState<ReportResponse>();
  const [reportEmpty, setReportEmpty] = useState(true);

  const getDateRange = () : {startDate:Date, endDate:Date} => {
    const now = new Date();
    const startDate = new Date(Date.UTC(now.getFullYear() - 1, now.getMonth(), 1));
    const endDate = new Date(Date.UTC(now.getFullYear(), now.getMonth(), 0));
    return {
      startDate,
      endDate
    }
  }

  const [dateRange, setDateRange] = useState(() => getDateRange());

  const validIds = ["103350319S1"];

  const DmStats = ({data}:DmStatsProps) => {
    //console.log('dmstats', data)
    
    const validNames = ["ring til din bedrift", "klikk til din bedrifts hjemmeside", "epost sendt til din bedrift"];
    const totalInquiry = data.activityResult.reduce((sum, item) => {
      if (validNames.includes(item.name.toLocaleLowerCase())) {
        return sum + item.count;
      }
        return sum;
    }, 0);
    
    return (
      <>
        {validIds.includes(params.id as string) && (
          <div className="row">
            <TelephoneInquiries inquiries={data.telephoneInquiries} />
            <ClickInquiries click={data.clickInquiries}/>
          </div>
        )}
        <DetailedDisplays data={data.detailedDisplaysResult} company={data.company} />
        <Visibility data={data.visibility} />
        <SearchWord data={data.searchWordCustomerResult}  company={data.company} />
        <ActivityAndTraffic activity={data.activityResult} traffic={data.trafficResult} company={data.company} />
        <PotentialTradeArea data={data.tradeAreaPotential} />
        <Potential data={data.detailedPotentialResult} company={data.company} />
        <RoiCalculator inquiry={totalInquiry} />
        <RelevantAlternatives data={data.relevantAlternative} />
        <GeographicalInfosite />
      </>
    )
  }

  useEffect(() => {
    if(loading) {
      const {startDate, endDate} = dateRange;
      statisticsService.getReport(params.id as string, startDate, endDate).then((reportData) => {
        setReport(reportData);
        setReportEmpty(!reportData || Object.keys(reportData).length === 0);
      }).catch((err) => {
        console.log("Error when catch:", err);
      }).finally(() => {
        setLoading(false);
      })
    }
    
  }, [loading, params.id, dateRange]);
  
  return (
    <>
      <Seo title="Min statistikk" />
      {loading && <LoadingScreen />}
      {!loading && reportEmpty && (
        <p className='text-danger'>Vi klarte ikke å hente dataene for din statistikk akkurat nå. Vennligst prøv å oppdatere siden. Hvis problemet vedvarer, ta kontakt med kundeservice for videre hjelp.</p>
      )}
      {!loading && !reportEmpty && report && (
        <>
          <BreadcrumbCompany />
          <h1 className="h3">
            Statistikk&nbsp;
            <span data-bs-toggle="modal" data-bs-target="#modalStatDate" role="button" className="link-primary">
              {formatDate(report.startDate, report.endDate)} <sup><small><i className="bi bi-calendar-week"></i></small></sup>
            </span>
          </h1>
          
          <DmStats data={report} />
          <Blog id={"min-bedrift-promo-for-dm1881no"}/>
          <p className="mt-4 mb-0">
            <Link to={UrlPath.MyAccount.Home} className="btn btn-outline-primary">
              <i className="bi bi-arrow-left"></i> Tilbake
            </Link>
          </p>
          <ModalStatDate
            startTime={report.startDate}
            endTime={report.endDate}          
            onChange={(newStart, newEnd) => {
              setDateRange({ startDate: newStart, endDate: newEnd });
              setLoading(true);
            }} />
        </>
      )}
    </>
  )
}